
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { fetchAllRoleList } from '@/api/role';
import { allocRole, getRoleByAdmin } from '@/api/login';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
        form: {},
        allRoleList: []
    },
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
            await dispatch('getAllRoleList');
            await dispatch('getRoleListByAdmin');
        },
        async getAllRoleList({ commit, state }) {
            const response = await fetchAllRoleList();
            commit('save', {
                allRoleList: response.data
            });
        },
        async getRoleListByAdmin({ commit, state }) {
            const { form, id } = state;
            const response = await getRoleByAdmin(id);
            const allocRoleList = response.data || [];
            let ids = [];
            allocRoleList.map((v) => {
                ids.push(v.id)
            });
            commit('save', {
                form: {
                    ...form,
                    ids: ids
                }
            })
		},
		async allocRole({ commit, state }) {
			const { id, form } = state;
			let params = new URLSearchParams();
			params.append("adminId", id);
			params.append("roleIds", form.ids);
			await allocRole(params);
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/admin/alloc-dialog.js